<template>
  <div class="customer-form">
    <toolbar
      backRoute="/dashboard/customers"
      :beforeBack="checkForChanges"
      :title="toolbarTitle"
      :deleteButtonLabel="deleteButtonLabel"
      deleteButtonEvent="customer-item-delete"
      saveButtonLabel="Save customer"
      saveButtonEvent="customer-item-save"
      :deleteInProgress="removeInProgress"
      :saveInProgress="saveInProgress" />

    <d-container fluid class="common-form px-0 pt-5 pb-5">
      <d-form>
        <validation-observer ref="customer-form" tag="form" v-if="!loadError && allDataLoaded">
          <d-row>
            <d-col cols="6">
              <d-row class="form-group">
                <d-col cols="6">
                  <label for="name">Company Name:</label>

                  <validation-provider
                    rules="required"
                    name="name"
                    v-slot="{ errors }">
                    <d-input
                      v-model="data.name"
                      :state="errors.length ? 'invalid' : null" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>

                  <label for="name" class="mt-3">Code:</label>

                  <validation-provider
                    rules="required"
                    name="code"
                    v-slot="{ errors }">
                    <d-input
                      v-model="data.code"
                      :state="errors.length ? 'invalid' : null" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>

                  <d-checkbox
                    inline
                    v-model="data.is_operator"
                    toggle
                    class="mt-4">
                      Is operator
                  </d-checkbox>
                </d-col>

                <d-col cols="6">
                  <label>
                    Logo:
                  </label>

                  <div
                    v-if="data.logo_url"
                    class="customer-logo">
                    <img :src="data.logo_url" />
                  </div>

                  <div v-if="data.logo_url">
                    <a
                      href="#"
                      @click.prevent="removeCustomerLogo()"
                      class="text-danger">
                      <small>Remove logo</small>
                    </a>
                  </div>

                  <file-input
                    v-if="!data.logo_url"
                    :onChange="setCustomerLogo"
                    id="inputFileCustomerLogo" />
                </d-col>
              </d-row>

              <div
                v-if="data.is_operator"
                class="form-group">
                <label for="notes">Trip handling request statement:</label>
                <d-textarea
                  v-model="data.trip_handling_request_statement"
                  :value.prop="data.trip_handling_request_statement"
                  style="height: 60px;"
                  :rows="5" />
              </div>

              <div class="form-group">
                <label for="address_line_1">Address line 1:</label>
                <d-input v-model="data.address_line_1" />
              </div>

              <div class="form-group">
                <label for="address_line_2">Address line 2:</label>
                <d-input v-model="data.address_line_2" />
              </div>

              <div class="form-group">
                <label for="town">Town:</label>
                <d-input v-model="data.town" />
              </div>

              <d-row>
                <d-col cols="4">
                  <div class="form-group">
                    <label for="post_code">Post code:</label>
                    <d-input v-model="data.post_code" />
                  </div>
                </d-col>

                <d-col cols="8">
                  <div class="form-group">
                    <label for="country_id">Country:</label>

                    <validation-provider
                      rules="required"
                      name="country_id"
                      v-slot="{ errors }">
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="countriesOptions"
                          v-model="data.country_id"
                          :reduce="country => country.id"
                          placeholder="Select a country"
                          label="text">
                          <template slot="no-options">
                            There are no countries for the provided phrase&hellip;
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <div class="form-group">
                <label for="email">Operator TAX ID:</label>
                <d-input v-model="data.operator_tax_id" />
              </div>

              <div class="form-group">
                <label for="email">E-mail:</label>
                <d-input v-model="data.email" />
              </div>
            </d-col>

            <d-col cols="6">
              <div class="form-group">
                <label for="invoice_name">Invoice name:</label>
                <d-input v-model="data.invoice_name" />
              </div>

              <div class="form-group">
                <label for="invoice_tax_id">Invoice TAX ID:</label>
                <d-input v-model="data.invoice_tax_id" />
              </div>

              <div class="form-group">
                <label for="invoice_address_line_1">Invoice address line 1:</label>
                <d-input v-model="data.invoice_address_line_1" />
              </div>

              <div class="form-group">
                <label for="invoice_address_line_2">Invoice address line 2:</label>
                <d-input v-model="data.invoice_address_line_2" />
              </div>

              <div class="form-group">
                <label for="invoice_address_line_3">Invoice address line 3:</label>
                <d-input v-model="data.invoice_address_line_3" />
              </div>

              <div class="form-group">
                <label for="invoice_town">Invoice town:</label>
                <d-input v-model="data.invoice_town" />
              </div>

              <d-row>
                <d-col cols="4">
                  <div class="form-group">
                    <label for="invoice_post_code">Invoice post code:</label>
                    <d-input v-model="data.invoice_post_code" />
                  </div>
                </d-col>

                <d-col cols="8">
                  <div class="form-group">
                    <label for="invoice_country">Invoice country:</label>
                    <d-input v-model="data.invoice_country" />
                  </div>
                </d-col>
              </d-row>

              <div class="form-group">
                <label for="notes">Notes:</label>
                <d-textarea
                  v-model="data.notes"
                  :value.prop="data.notes"
                  style="height: 116px;"
                  :rows="9" />
              </div>

              <div class="form-group">
                <label for="debtor_email">Debtor e-mail:</label>
                <d-input v-model="data.debtor_email" />
              </div>
            </d-col>
          </d-row>
        </validation-observer>

        <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
          Loading data&hellip;
        </div>

        <d-alert
          v-if="loadError"
          show
          theme="warning">
          The app were unable to load data. <a href="javascript:window.location.reload();" class="alert-link">Refresh the app</a> to try again.
        </d-alert>
      </d-form>

      <airport-handlers-list
        v-if="loadedData"
        referenceType="CUSTOMER"
        :referenceId="data.id"
        :onlyOneHandlerPerAirport="true" />

      <airport-hotels-list
        v-if="loadedData"
        referenceType="CUSTOMER"
        :referenceId="data.id" />

      <fieldset class="mt-4 mb-4 ml-0 mr-0">
        <legend>Aircrafts</legend>

        <table
          v-if="data.aircrafts_regin_mark && data.aircrafts_regin_mark.length"
          class="table mt-3">
          <thead>
            <tr>
              <th class="text-center">Reg number</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(regin_mark, index) of data.aircrafts_regin_mark"
              :key="'aircraft-regin-mark-' + index">
              <td class="text-center">
                {{ regin_mark }}
              </td>
            </tr>
          </tbody>
        </table>
        <d-alert
          v-else
          show
          theme="light"
          class="text-center">
          There are no aircrafts for this customer&hellip;
        </d-alert>
      </fieldset>

      <checklist-list
        v-if="loadedData"
        referenceType="CUSTOMER"
        :referenceId="data.id"
        itemName="customer" />
    </d-container>
  </div>
</template>

<script>
import AirportHandlersList from './../form-parts/AirportHandlers.vue';
import AirportHotelsList from './../form-parts/AirportHotels.vue';
import ChecklistList from './../form-parts/CheckLists.vue';
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils.js';
import HasChangesDetection from './../../mixins/HasChangesDetection.vue';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'customer-form',
  mixins: [
    HasChangesDetection
  ],
  components: {
    'airport-handlers-list': AirportHandlersList,
    'airport-hotels-list': AirportHotelsList,
    'checklist-list': ChecklistList
  },
  computed: {
    allDataLoaded () {
      return this.loadedData && this.loadedCountries;
    },
    countriesOptions () {
      return CommonGetters.getCountriesForSelect(this.countries);
    },
    isEdit () {
      return this.$route.params.id !== 'new' && parseInt(this.$route.params.id, 10) > 0;
    },
    toolbarTitle () {
      if (!this.isEdit) {
        return 'Add new customer';
      }

      return 'Edit customer';
    },
    deleteButtonLabel () {
      if (this.$route.params.id === 'new') {
        return false;
      }

      return 'Delete customer';
    }
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        code: '',
        town: '',
        post_code: '',
        country_id: null,
        is_operator: false,
        logo: '',
        logo_url: '',
        notes: '',
        address_line_1: '',
        address_line_2: '',
        aircrafts_regin_mark: [],
        trip_handling_request_statement: '',
        invoice_name: '',
        invoice_address_line_1: '',
        invoice_address_line_2: '',
        invoice_address_line_3: '',
        invoice_town: '',
        invoice_post_code: '',
        invoice_country: '',
        invoice_tax_id: '',
        email: '',
        debtor_email: null,
        operator_tax_id: ''
      },
      countries: [],
      loadError: false,
      loadedData: false,
      loadedCountries: false,
      removeInProgress: false,
      saveInProgress: false
    };
  },
  mounted () {
    if (!this.isEdit) {
      this.loadedData = true;
      this.loadAdditionalData();
    } else {
      this.loadData();
    }

    this.$bus.$on('customer-item-delete', this.removeCustomer);
    this.$bus.$on('customer-item-save', this.validateForm);
  },
  methods: {
    setCustomerLogo (event) {
      this.data.logo = event.target.files[0];
      console.log(this.data.logo);
    },
    removeCustomerLogo () {
      this.data.logo_url = '';
      this.data.logo = '';
    },
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/customers/item/',
        instanceFields: ['id', 'name', 'code', 'town', 'post_code', 'country_id', 'email', 'logo', 'logo_url', 'trip_handling_request_statement', 'notes', 'address_line_1', 'address_line_2', 'aircrafts_regin_mark', 'invoice_name', 'invoice_address_line_1', 'invoice_address_line_2', 'invoice_address_line_3', 'invoice_town', 'invoice_post_code', 'invoice_country', 'invoice_tax_id', 'debtor_email', 'operator_tax_id'],
        loadedKey: 'loadedData',
        successAction: (response) => {
          this.data.is_operator = !!response.is_operator;
        }
      });

      this.loadAdditionalData();
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/items',
        params: {
          pagination: 0
        },
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError'
      });
    },
    removeCustomer () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/customers/delete/',
        id: parseInt(this.$route.params.id, 10),
        successTitle: 'Customer removed',
        successText: 'The selected customer has been removed',
        confirmTitle: 'Do you really want to remove this customer?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$router.push('/dashboard/customers');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-form'], this.submitForm);
    },
    submitForm () {
      let imageFields = false;
      let endpointUrl = '/customers/store';
      let mode = 'add';
      let formDataToSend = JSON.parse(JSON.stringify(this.data));
      delete formDataToSend.logo;
      delete formDataToSend.logo_url;

      if (this.id > 0) {
        endpointUrl = '/customers/update/' + parseInt(this.id, 10);
        mode = 'edit';
      }

      if (this.data.logo) {
        formDataToSend.logo = this.data.logo;
        imageFields = ['logo'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: this.data,
        successTitle: mode === 'add' ? 'Customer added' : 'Customer saved',
        successText: 'The customer has been successfully saved!',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          this.$router.push('/dashboard/customers');
        }
      }, imageFields);
    }
  },
  beforeDestroy () {
    this.$bus.$off('customer-item-delete', this.removeCustomer);
    this.$bus.$off('customer-item-save', this.validateForm);
  }
}
</script>

<style lang="scss" scoped>
.customer-logo {
  img {
    height: auto;
    width: 160px;
  }
}
</style>
